// /* eslint-disable no-shadow */
// import React from 'react';
// import { Formik } from 'formik';
// import { useMutation, useQuery } from '@apollo/client';
// import { toast } from 'react-toastify';
// import { GET_USER_KYC, UPDATE_USER_KYC } from 'utils/CommonGraphQL';
// import ErrorBoundary from 'components/common/ErrorBoundary';
// import Loader from 'components/common/Loader';
// import VendorKycForm from './components/VendorKycForm';
// // import { indianVendorKYCSchema } from 'components/Drawers/components/VendorDetailsDrawer/constant';

// const VendorKyc = ({ id }) => {
//   const { data, loading, error, refetch } = useQuery(GET_USER_KYC, {
//     variables: { id },
//     fetchPolicy: 'network-only',
//   });

//   const [updateUserKYC] = useMutation(UPDATE_USER_KYC, {
//     onCompleted: ({ updateUserKYC }) => {
//       toast.success(updateUserKYC);
//       refetch();
//     },
//     onError: ({ graphQLErrors }) => {
//       graphQLErrors.forEach(({ message }) => {
//         toast.error(message);
//       });
//     },
//   });
//   const handleSubmit = async (values) => {

//     // Remove query params from file URLs if present
//     const stripQuery = (file) => {
//       if (typeof file === 'string' && file.includes('?')) {
//       return file.split('?')[0];
//       }
//       return file;
//     };

//     const aadharFront = stripQuery(values?.aadharFront);
//     const aadharBack = stripQuery(values?.aadharBack);
//     const gstPhoto = stripQuery(values?.gstPhoto);
//     const panPhoto = stripQuery(values?.panPhoto);
//     const userVerificationDocument = stripQuery(values?.userVerificationDocument);

//     await updateUserKYC({
//       variables: {
//         input: {
//           ...values,
//           aadharFront: values?.aadharFront?.length ? aadharFront : null,
//           aadharBack: values?.aadharBack?.length ? aadharBack : null,
//           gstPhoto: values?.gstPhoto?.length ? gstPhoto : null,
//           panPhoto: values?.panPhoto?.length ? panPhoto : null,
//           aadharStatus:
//             values?.aadharFront?.length && values?.aadharBack?.length
//               ? 'completed'
//               : 'pending',
//           panStatus: values?.panPhoto?.length ? 'completed' : 'pending',
//           gstStatus: values?.gstPhoto?.length ? 'completed' : 'pending',
//           userVerificationDocument: values?.userVerificationDocument?.length
//             ? userVerificationDocument
//             : null,
//           userVerificationDocumentStatus: values?.userVerificationDocument
//             ?.length
//             ? 'completed'
//             : 'pending',
//         },
//       },
//     });
//     // drawerToggle();
//   };

//   if (loading) return <Loader />;
//   if (error) return `There is an error on this page : ${error.message} `;
//   if (!data?.userKYC) return 'User KYC not available';

//   return (
//     <ErrorBoundary>
//       <Formik
//         initialValues={{
//           id: data?.userKYC?.id,
//           aadharFront: data?.userKYC?.aadharFront
//             ? data?.userKYC?.aadharFront
//             : '',
//           aadharBack: data?.userKYC?.aadharBack
//             ? data?.userKYC?.aadharBack
//             : '',
//           aadharStatus: data?.userKYC?.aadharStatus,
//           gstPhoto: data?.userKYC?.gstPhoto ? data?.userKYC?.gstPhoto : '',
//           gstStatus: data?.userKYC?.gstStatus,
//           panPhoto: data?.userKYC?.panPhoto ? data?.userKYC?.panPhoto : '',
//           panStatus: data?.userKYC?.panStatus,
//           userVerificationDocument: data?.userKYC?.userVerificationDocument
//             ? data?.userKYC?.userVerificationDocument
//             : '',
//           userVerificationDocumentStatus:
//             data?.userKYC?.userVerificationDocumentStatus,
//           kycStatus: null,
//         }}
//         enableReinitialize
//         // validationSchema={indianVendorKYCSchema}
//         onSubmit={handleSubmit}
//         children={(props) => {
//           return <VendorKycForm {...props} />;
//         }}
//       />
//     </ErrorBoundary>
//   );
// };

// export default VendorKyc;

/* eslint-disable no-shadow */
import React from 'react';
import { Formik } from 'formik';
import { useMutation, useQuery } from '@apollo/client';
import { toast } from 'react-toastify';
import { GET_USER_KYC, UPDATE_USER_KYC } from 'utils/CommonGraphQL';
import ErrorBoundary from 'components/common/ErrorBoundary';
import Loader from 'components/common/Loader';
import VendorKycForm from './components/VendorKycForm';

const VendorKyc = ({ id, onTimelineRefresh = () => {} }) => {
  const { data, loading, error, refetch } = useQuery(GET_USER_KYC, {
    variables: { id },
    fetchPolicy: 'network-only',
  });

  const [updateUserKYC] = useMutation(UPDATE_USER_KYC, {
    onCompleted: ({ updateUserKYC }) => {
      toast.success(updateUserKYC);
      refetch();
      onTimelineRefresh();
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
      });
    },
  });

  const handleSubmit = async (values) => {
    // Remove query params from file URLs if present
    const stripQuery = (file) => {
      if (typeof file === 'string' && file.includes('?')) {
        return file.split('?')[0];
      }
      return file;
    };

    const aadharFront = stripQuery(values?.aadharFront);
    const aadharBack = stripQuery(values?.aadharBack);
    const gstPhoto = stripQuery(values?.gstPhoto);
    const panPhoto = stripQuery(values?.panPhoto);
    const userVerificationDocument = stripQuery(
      values?.userVerificationDocument,
    );

    await updateUserKYC({
      variables: {
        input: {
          ...values,
          aadharFront: values?.aadharFront?.length ? aadharFront : null,
          aadharBack: values?.aadharBack?.length ? aadharBack : null,
          gstPhoto: values?.gstPhoto?.length ? gstPhoto : null,
          panPhoto: values?.panPhoto?.length ? panPhoto : null,
          aadharStatus:
            values?.aadharFront?.length && values?.aadharBack?.length
              ? 'completed'
              : 'pending',
          panStatus: values?.panPhoto?.length ? 'completed' : 'pending',
          gstStatus: values?.gstPhoto?.length ? 'completed' : 'pending',
          userVerificationDocument: values?.userVerificationDocument?.length
            ? userVerificationDocument
            : null,
          userVerificationDocumentStatus: values?.userVerificationDocument
            ?.length
            ? 'completed'
            : 'pending',
          // Don't update kycStatus if GST is not available
          kycStatus: null, // Keep this as null to maintain current status
        },
      },
    });
  };

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;
  if (!data?.userKYC) return 'User KYC not available';

  return (
    <ErrorBoundary>
      <Formik
        initialValues={{
          id: data?.userKYC?.id,
          aadharFront: data?.userKYC?.aadharFront
            ? data?.userKYC?.aadharFront
            : '',
          aadharBack: data?.userKYC?.aadharBack
            ? data?.userKYC?.aadharBack
            : '',
          aadharStatus: data?.userKYC?.aadharStatus,
          gstPhoto: data?.userKYC?.gstPhoto ? data?.userKYC?.gstPhoto : '',
          gstStatus: data?.userKYC?.gstStatus,
          panPhoto: data?.userKYC?.panPhoto ? data?.userKYC?.panPhoto : '',
          panStatus: data?.userKYC?.panStatus,
          userVerificationDocument: data?.userKYC?.userVerificationDocument
            ? data?.userKYC?.userVerificationDocument
            : '',
          userVerificationDocumentStatus:
            data?.userKYC?.userVerificationDocumentStatus,
          kycStatus: null,
        }}
        enableReinitialize
        onSubmit={handleSubmit}
        children={(props) => {
          return <VendorKycForm {...props} />;
        }}
      />
    </ErrorBoundary>
  );
};

export default VendorKyc;
